var _circle, _circle2, _g, _circle3, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifiHalfFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 39.75,
    stroke: "#92278F",
    strokeWidth: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_223_3112",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 81
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.5,
    r: 40,
    fill: "#92278F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_223_3112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.42857 51.4924C-9.41818 38.8285 -25.8766 46.2158 -32 51.4924V102.5H106V51.4924C92.7377 65.5635 76.5779 57.3554 70.1558 51.4924C57.6104 39.8838 43.7208 46.6555 38.3442 51.4924C26.874 60.9904 12.9545 55.4499 7.42857 51.4924Z",
    fill: "#92278F"
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.5,
    r: 39.75,
    stroke: "#92278F",
    fill: "none",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8701 23.5C48.5159 23.6131 55.8738 26.4418 62.045 32.0424C62.6383 32.6082 63.0537 33.2305 62.9944 34.0225C62.935 34.9276 62.401 35.5499 61.5109 35.8894C60.6208 36.2288 59.8495 36.0025 59.0781 35.3802C57.654 34.2488 56.2892 33.0607 54.8057 32.0424C51.0674 29.6098 46.9138 28.2521 42.4041 27.9126C35.2836 27.3469 28.9344 29.1572 23.2973 33.3436C22.4666 33.9659 21.6952 34.7013 20.8645 35.3802C20.1524 35.9459 19.381 36.1156 18.4909 35.7762C17.6009 35.4933 17.1262 34.871 17.0075 34.0225C16.9481 33.3436 17.2448 32.7213 17.7789 32.2121C20.4491 29.6664 23.5347 27.6298 27.0356 26.1023C31.1299 24.3486 35.5209 23.5 41.8701 23.5Z",
    fill: "#92278F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6152 32.2121C46.0831 32.3253 51.3641 34.3053 55.7551 38.4351C56.7045 39.3403 56.7639 40.6414 55.8738 41.5466C54.9837 42.4517 53.5596 42.4517 52.5509 41.5466C49.8807 39.0574 46.7951 37.4734 43.1162 36.8511C37.7758 35.9459 32.91 37.1905 28.6377 40.4717C28.2224 40.8111 27.807 41.2072 27.3916 41.5466C26.4422 42.3952 25.0774 42.3952 24.128 41.5466C23.238 40.698 23.238 39.3403 24.1874 38.4917C27.7476 35.0973 32.0793 33.0607 37.0637 32.4384C38.0131 32.2687 38.9625 32.2687 39.6152 32.2121Z",
    fill: "#92278F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7932 40.9243C43.4722 40.9809 46.5578 42.1123 49.1686 44.3752C50.4147 45.4501 50.1774 46.8078 49.584 47.5433C48.6939 48.5616 47.2105 48.6181 46.1424 47.6564C45.1337 46.7513 44.0062 46.0158 42.6415 45.6764C39.3779 44.7712 36.4703 45.4501 33.9781 47.6564C33.0287 48.505 31.7826 48.6181 30.8332 47.8827C29.7651 47.0341 29.6465 45.6198 30.5959 44.6581C32.732 42.6215 35.3429 41.3769 38.3691 41.0374C38.9032 40.9809 39.4372 40.9243 39.7932 40.9243Z",
    fill: "#92278F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0656 53.5965C44.0656 55.7463 42.2261 57.5 39.9713 57.5C37.7164 57.5 35.8769 55.7463 35.8769 53.5965C35.8769 51.4468 37.7164 49.693 39.9713 49.6364C42.2261 49.6364 44.0656 51.3902 44.0656 53.5965Z",
    fill: "#92278F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiHalfFilled);
export default __webpack_public_path__ + "static/media/wifi-half-filled.5ce17e7bfdb27b2be43b512d55d2ccff.svg";
export { ForwardRef as ReactComponent };